import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import {
	userHomeCardBlurClassName,
	userHomeCardClassName,
	userHomeCardHeaderClassName,
	userHomeCardIconBoxClassName,
	userHomeSectionLabelClassName,
} from './userHomeCardStyles';

type UserHomeCardProps = {
	children: ReactNode;
	className?: string;
};

const UserHomeCard = ({ children, className }: UserHomeCardProps) => (
	<section className={cn(userHomeCardClassName, className)}>
		<div className={userHomeCardBlurClassName} aria-hidden>
			<div className="absolute -right-10 top-0 h-32 w-32 rounded-full bg-brand-orange/20 blur-3xl" />
			<div className="absolute bottom-0 left-[20%] h-24 w-24 rounded-full bg-brand-orange/15 blur-2xl" />
		</div>
		<div className="relative z-10 space-y-5">{children}</div>
	</section>
);

type UserHomeCardHeaderProps = {
	icon: ReactNode;
	label: string;
	title: string;
	description: string;
};

const UserHomeCardHeader = ({
	icon,
	label,
	title,
	description,
}: UserHomeCardHeaderProps) => (
	<div className={userHomeCardHeaderClassName}>
		<div className={userHomeCardIconBoxClassName}>{icon}</div>
		<div className="space-y-1">
			<p className={userHomeSectionLabelClassName}>{label}</p>
			<h2 className="text-xl font-bold text-zinc-900 md:text-2xl">
				{title}
			</h2>
			<p className="text-sm leading-relaxed text-zinc-500 md:text-[15px]">
				{description}
			</p>
		</div>
	</div>
);

export { UserHomeCard, UserHomeCardHeader };
